import * as _ from 'lodash';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import initialState from './initialState';
import * as TaskUtilities from '../../../../HelperMethods/TaskUtilities';
import { getActionTypes, mergeAssigneesForNeedsEquipmentTaskType } from '../../../../HelperMethods/UtilityFunctions';
import { EditMode, TASK_SOURCE, VIEWS } from '../../../../HelperMethods/constants';
import * as helper from '../../../userManagement/lib/helper';

/**
 * function set null to sequence of assigneeId
 * if assigneeId is null, sequence should be set null for all assignees
 * @param task
 * @param assigneeId
 */
function setSequenceNullAndStateDirtyToTaskForAssigneeId(task, assigneeId) {
  const clonedTask = _.cloneDeep(task);
  for (const assignee of clonedTask.assigneeIds) {
    if (!assignee.isDeleted && assignee.sequence && (assigneeId ? assignee.assigneeId === assigneeId : true)) {
      assignee.sequence = null;
      clonedTask.isDirty = true;
    }
  }
  return clonedTask;
}
function getVirtualTasks() {
  // tasks, startDate, endDate function parameters
  // as per new implementation, there won't be any virtual tasks
  return [];
  // startDate = typeof startDate === 'string' ? moment(startDate).startOf('day') : moment(startDate);

  // if (!endDate) endDate = moment(startDate).endOf('day');
  // else endDate = typeof endDate === 'string' ? moment(endDate).endOf('day') : moment(endDate);

  // const tomorrow = moment().add(1, 'days').startOf('day');
  // if (startDate.isBefore(tomorrow)) {
  //   // here making sure virtual tasks are not being generated for past days
  //   startDate = tomorrow;
  // }

  // if (endDate.isBefore(startDate)) {
  //   return [];
  // }

  // startDate = startDate.toDate();
  // endDate = endDate.toDate();
  // const virtualTasks = [];

  // (tasks || [])
  //   .filter((task) => task.isRecurring && !task.workflowVersion)
  //   .forEach((task) => {
  //     virtualTasks.push(...UtilityFunctions.getVirtualRecurringTasksFromOriginalTask(task, startDate, endDate));
  //   });
  // return virtualTasks;
}

function combineVirtualTasksWithDbTasks(virtualTasks, dbTasks, dontCombine = false) {
  if (dontCombine) {
    return virtualTasks;
  }

  return [...virtualTasks, ...(dbTasks || [])];

  // as per new implementation, there won't be any virtual tasks
  // const dateFormatYYYYMMDD = 'YYYY-MM-DD';
  // const todaysDate = moment().format(dateFormatYYYYMMDD);
  // const materialisedTasks = (dbTasks || []).filter((task) =>
  //   TaskUtilities.isTaskOccurrenceOfRecurringAndMaterialized(task)
  // );

  // // if there is a materialized task of a particular recurrence for some date then virtual task of that corresponding recurrence for that date needs to be discarded
  // const dbTasksMap = _.keyBy(
  //   materialisedTasks,
  //   (task) => `${task.sourceRecurringTaskId}#${moment(task.originalRecurrenceDate).format(dateFormatYYYYMMDD)}`
  // );
  // for (let i = 0; i < virtualTasks.length; i += 1) {
  //   const virtualTask = virtualTasks[i];
  //   if (
  //     dbTasksMap[
  //       `${virtualTask.sourceRecurringTaskId}#${moment(virtualTask.originalRecurrenceDate).format(dateFormatYYYYMMDD)}`
  //     ]
  //   ) {
  //     virtualTasks.splice(i, 1);
  //     i -= 1;
  //   }
  // }

  // // it may happen that materialized task will get spilled over to current date, hence for current date the virtual task should not get created
  // const todayDbTasksMap = _.keyBy(
  //   materialisedTasks.filter((t) => moment(t.startTime).format(dateFormatYYYYMMDD) === todaysDate),
  //   (t) => `${t.sourceRecurringTaskId}#${todaysDate}`
  // );

  // for (let i = 0; i < virtualTasks.length; i += 1) {
  //   const virtualTask = virtualTasks[i];
  //   if (
  //     todayDbTasksMap[
  //       `${virtualTask.sourceRecurringTaskId}#${moment(virtualTask.startTime).format(dateFormatYYYYMMDD)}`
  //     ]
  //   ) {
  //     virtualTasks.splice(i, 1);
  //     i -= 1;
  //   }
  // }

  // if (dontCombine) {
  //   return virtualTasks;
  // }

  // return [...virtualTasks, ...(dbTasks || [])];
}

function mergeAssigneeIdsWithDeletedAssigneeIds(assigneeIds, originalAssigneeIds, users, needEquipment) {
  if (needEquipment) {
    return mergeAssigneesForNeedsEquipmentTaskType(assigneeIds, originalAssigneeIds, users, needEquipment);
  }
  const deletedAssigneeIds = originalAssigneeIds.filter((a) => a.isDeleted);
  return _.unionBy(assigneeIds, deletedAssigneeIds, 'assigneeId');
}

function doesUserBelongToAreas(areas, user) {
  return areas.some((area) => {
    const resourcesInArea = (area.teams || [])
      .filter((t) => !t.isDeleted)
      .flatMap((team) => {
        return team.resources.filter((r) => !r.isDeleted).map((r) => r.userId);
      });

    return resourcesInArea.includes(user.id);
  });
}

const actionTypes = getActionTypes('taskViewPage')(['SET_USERS', 'SET_TASKS']);

export function setUsers(users) {
  return { type: actionTypes.SET_USERS, users };
}

export function setTasks(tasks, taskSource, doNotUpdateVersion) {
  return {
    type: actionTypes.SET_TASKS,
    tasks,
    taskSource: taskSource || TASK_SOURCE.NON_SUBSCRIPTION,
    doNotUpdateVersion: !!doNotUpdateVersion,
  };
}

const pageTitle = 'TASK_VIEW_PAGE';
export const types = {
  BULK_EDIT_TASKS: `${pageTitle}_BULK_EDIT_TASKS`,
  LOADED_ALL_TASKS: `${pageTitle}_LOADED_ALL_TASKS`,
  LOADING_ALL_TASKS: `${pageTitle}_LOADING_ALL_TASKS`,
  LOADING_ALL_TASKS_FAILED: `${pageTitle}_LOADING_ALL_TASKS_FAILED`,
  UPSERT_TASKS: `${pageTitle}_UPSERT_TASKS`,
  DELETE_TASK_SUCCESS: `${pageTitle}_DELETE_TASK_SUCCESS`,
  BULK_DELETE_SUCCESSFUL: `${pageTitle}_BULK_DELETE_SUCCESSFUL`,
  BULK_DELETE_FAILED: `${pageTitle}_BULK_DELETE_FAILED`,
  TASK_PAGE_LOADING: `${pageTitle}_TASK_PAGE_LOADING`,
  TASK_PAGE_LOADED: `${pageTitle}_TASK_PAGE_LOADED`,
  RUN_ENGINE_SUCCESS: `${pageTitle}_RUN_ENGINE_SUCCESS`,
  RUN_ENGINE_FAILED: `${pageTitle}_RUN_ENGINE_FAILED`,
  PLANNING_ENGINE_PROGRESS: `${pageTitle}_PLANNING_ENGINE_PROGRESS`,
  PLANNING_ENGINE_SUCCESS: `${pageTitle}_PLANNING_ENGINE_SUCCESS`,
  PLANNING_ENGINE_FAILED: `${pageTitle}_PLANNING_ENGINE_FAILED`,
  UPDATE_DELETED_FOR_RECURRENCE_DATE_TASK_SUCCESS: `${pageTitle}_UPDATE_DELETED_FOR_RECURRENCE_DATE_TASK_SUCCESS`,
  LOADING_ALL_USERS: `${pageTitle}_LOADING_ALL_USERS`,
  LOADING_ALL_USERS_FAILED: `${pageTitle}_LOADING_ALL_USERS_FAILED`,
  LOADED_ALL_USERS: `${pageTitle}_LOADED_ALL_USERS`,
  TASK_TIME_UPDATED: `${pageTitle}_TASK_TIME_UPDATED`,
  BULK_UNASSIGNED_USER_SUCCESSFUL: `${pageTitle}_BULK_UNASSIGNED_USER_SUCCESSFUL`,
  BULK_UNASSIGNED_USER_FAILED: `${pageTitle}_BULK_UNASSIGNED_USER_FAILED`,
  UPDATE_TASK_TIME_DIRTY_STATE: `${pageTitle}_UPDATE_TASK_TIME_DIRTY_STATE`,
  GRID_DATE_CHANGED: `${pageTitle}_GRID_DATE_CHANGED`,
  CHANGE_TASK_VIEW_PAGE_VIEW: `${pageTitle}_CHANGE_TASK_VIEW_PAGE_VIEW`,
  UPDATE_TASKS_FROM_SCHEDULER: `${pageTitle}_UPDATE_TASKS_FROM_SCHEDULER`,
  CHANGE_TASK_EDIT_MODE: `${pageTitle}_CHANGE_TASK_EDIT_MODE`,
  CHANGE_TASK_PLANNING_MODE: `${pageTitle}_CHANGE_TASK_PLANNING_MODE`,
  CHANGE_TASK_PLANNING_MESSAGE: `${pageTitle}_CHANGE_TASK_PLANNING_MESSAGE`,
  LOADING_USERS_AT_FIELD_LEVEL: `${pageTitle}_LOADING_USERS_AT_FIELD_LEVEL`,
  LOAD_USERS_AT_FIELD_LEVEL_SUCCESS: `${pageTitle}_LOAD_USERS_AT_FIELD_LEVEL_SUCCESS`,
  LOAD_USERS_AT_FIELD_LEVEL_FAILED: `${pageTitle}_LOAD_USERS_AT_FIELD_LEVEL_FAILED`,
  CREATING_TASK: `${pageTitle}_CREATING_TASK`,
  CREATED_TASK_SUCCESSFULLY: `${pageTitle}_CREATED_TASK_SUCCESSFULLY`,
  CREATED_TASK_FAILED: `${pageTitle}_CREATED_TASK_FAILED`,
  UPDATING_TASK: `${pageTitle}_UPDATING_TASK`,
  UPDATED_TASK_SUCCESSFULLY: `${pageTitle}_UPDATED_TASK_SUCCESSFULLY`,
  UPDATED_TASK_FAILED: `${pageTitle}_UPDATED_TASK_FAILED`,
  APPROVING_TASK: `${pageTitle}_APPROVING_TASK`,
  APPROVED_TASK_SUCCESSFULLY: `${pageTitle}_APPROVED_TASK_SUCCESSFULLY`,
  APPROVED_TASK_FAILED: `${pageTitle}_APPROVED_TASK_FAILED`,
  LOAD_TASK_USERS_SUBSCRIPTION_SUCCESS: `LOAD_TASK_USERS_SUBSCRIPTION_SUCCESS`,
  LOAD_TASK_USERS_SUBSCRIPTION_FAILED: `LOAD_TASK_USERS_SUBSCRIPTION_FAILED`,
  BULK_EDIT_TASKS_SUCCESSFULL: 'BULK_EDIT_TASKS_SUCCESSFULL',
  UPDATE_MERGE_TASK: `${pageTitle}_UPDATE_MERGE_TASK`,
  UPDATE_TEAMS_OF_USERS: `${pageTitle}_UPDATE_TEAMS_OF_USERS`,
  LOAD_FILTERS: `${pageTitle}_FETCH_FILTERS_SUCCESS`,
  UPSERT_FILTER: `${pageTitle}_UPSERT_FILTER`,
  DELETE_FILTER: `${pageTitle}_DELETE_FILTER`,
  UPSERT_PARENT_CHILD_TASKS: `${pageTitle}_UPSERT_PARENT_CHILD_TASKS`,
  UPDATE_PARENT_CHILD_MERGE_TASK: `${pageTitle}_UPDATE_PARENT_CHILD_MERGE_TASK`,
  BULK_EDIT_PAGE_LOADED: `${pageTitle}_BULK_EDIT_PAGE_LOADED`,
  BULK_EDIT_PAGE_LOADING: `${pageTitle}_BULK_EDIT_PAGE_LOADING`,
  UPDATE_SELECTED_USER_IDS: `${pageTitle}_UPDATE_SELECTED_USER_IDS`,
  FILTERED_DATA: `${pageTitle}_FILTERED_DATA`,
  SCHEDULER_PAGE_LOADING: `${pageTitle}_SCHEDULER_PAGE_LOADING`,
  SCHEDULER_PAGE_LOADED: `${pageTitle}_SCHEDULER_PAGE_LOADED`,
  LOCK_TASKS_FROM_SCHEDULER: `${pageTitle}_LOCK_TASKS_FROM_SCHEDULER`,
  UPDATE_IFRAME_STATE: `${pageTitle}_UPDATE_IFRAME_STATE`,
  UPDATE_PARENT_CHILD_TASKS: `${pageTitle}_UPDATE_PARENT_CHILD_TASKS`,
  UPSERT_WATCHERS: `${pageTitle}_UPSERT_WATCHERS`,
  UPSERT_ASSET_LEVELS_INFO: `${pageTitle}_UPSERT_ASSET_LEVELS_INFO`,
};

export function upsertTasks(tasks, source) {
  return { type: types.UPSERT_TASKS, tasks, source };
}

export function upsertParentChildTasks(tasks) {
  return { type: types.UPSERT_PARENT_CHILD_TASKS, tasks };
}

export function updateParentChildTasks(tasks) {
  return { type: types.UPDATE_PARENT_CHILD_TASKS, tasks };
}

export function bulkEditPageLoading() {
  return { type: types.BULK_EDIT_PAGE_LOADING };
}
export function stopBulkEditPageLoading() {
  return { type: types.BULK_EDIT_PAGE_LOADED };
}
export function stopPageLoading() {
  return { type: types.TASK_PAGE_LOADED };
}

export function startPageLoading() {
  return { type: types.TASK_PAGE_LOADING };
}

export function loadFilters(filters) {
  return { type: types.LOAD_FILTERS, filters };
}
export function upsertFilter(filter) {
  return { type: types.UPSERT_FILTER, filter };
}
export function deleteFilter(id) {
  return { type: types.DELETE_FILTER, id };
}

export function lockTask(taskIds, isTaskLocked, isDirty) {
  return { type: types.LOCK_TASKS_FROM_SCHEDULER, taskIds, isTaskLocked, isDirty };
}

export function upsertWatchers(watchers) {
  return { type: types.UPSERT_WATCHERS, watchers };
}

export function upsertAssetLevelsInfo(assetLevelsObjects) {
  return { type: types.UPSERT_ASSET_LEVELS_INFO, assetLevelsObjects };
}

export default function taskViewPageReducer(state = initialState, action) {
  switch (action.type) {
    case types.FILTERED_DATA: {
      const { tasks } = action;

      return {
        ...state,
        filteredUserIdsFromTaskListFilter: [...tasks],
      };
    }
    case types.BULK_EDIT_PAGE_LOADED: {
      return {
        ...state,
        bulkEditTasks: {
          items: _.get(state, 'bulkEditTasks.items', []),
          component: _.get(state, 'bulkEditTasks.component', {}),
          isLoading: false,
        },
      };
    }
    case types.BULK_EDIT_PAGE_LOADING: {
      return {
        ...state,
        bulkEditTasks: {
          items: _.get(state, 'bulkEditTasks.items', []),
          component: _.get(state, 'bulkEditTasks.component', {}),
          isLoading: true,
        },
      };
    }
    case types.UPDATE_IFRAME_STATE: {
      const { iframepresentState } = action;
      return {
        ...state,
        iframepresentState,
      };
    }

    case types.BULK_EDIT_TASKS: {
      const { tasks } = action;
      return {
        ...state,
        bulkEditTasks: {
          items: tasks,
          component: {},
          isLoading: false,
        },
      };
    }

    case types.LOADED_ALL_TASKS: {
      let startDate;
      let endDate;
      if (state.currentView === VIEWS.schedulerView) {
        startDate = state.scheduler.startDate;
        endDate = state.scheduler.endDate;
      } else {
        startDate = state.selectedDateRange.startDate;
        endDate = state.selectedDateRange.endDate;
      }

      if (state.tasksEditMode === EditMode.UNPUBLISHED) {
        const dirtyTasks = state.tasks.items.filter((t) => t.isDirty);
        action.tasks = _.unionBy(dirtyTasks, action.tasks, 'id');
      }

      const virtualTasks = getVirtualTasks(action.tasks, startDate, endDate);
      const allTasks = combineVirtualTasksWithDbTasks(virtualTasks, action.tasks);

      return {
        ...state,
        tasks: {
          items: allTasks,
          isLoading: false,
          version: uuid(),
          taskSource: TASK_SOURCE.NON_SUBSCRIPTION,
        },
      };
    }

    case types.LOADING_ALL_TASKS:
      return {
        ...state,
        tasks: {
          items: state.tasks.items,
          isLoading: true,
          version: state.tasks.version,
          taskSource: TASK_SOURCE.NON_SUBSCRIPTION,
        },
      };
    case types.LOADING_ALL_TASKS_FAILED:
      return {
        ...state,
        tasks: {
          items: [],
          isLoading: false,
          version: uuid(),
          taskSource: TASK_SOURCE.NON_SUBSCRIPTION,
        },
      };
    case types.UPSERT_TASKS: {
      const { tasks, source = TASK_SOURCE.NON_SUBSCRIPTION } = action;
      let startDate;
      let endDate;
      if (state.currentView === VIEWS.schedulerView) {
        startDate = state.scheduler.startDate;
        endDate = state.scheduler.endDate;
      } else {
        startDate = state.selectedDateRange.startDate;
        endDate = state.selectedDateRange.endDate;
      }
      let allTasks = state.tasks.items;
      let reqTasks = tasks;
      if (source === TASK_SOURCE.SUBSCRIPTION) {
        const taskIds = new Set(tasks.map((t) => t.id));
        allTasks = allTasks.filter((t) => !(taskIds.has(t.sourceRecurringTaskId) && t.isVirtual));
        const virtualTasks = getVirtualTasks(tasks, startDate, endDate);
        reqTasks = combineVirtualTasksWithDbTasks(virtualTasks, tasks);
      }
      const updatedTaskIds = new Set(reqTasks.map((t) => t.id));
      const newTasks = [...allTasks.filter((t) => !updatedTaskIds.has(t.id)), ...reqTasks];
      const dirtyTasks = newTasks.filter((t) => t.isDirty);
      const tasksEditMode = dirtyTasks.length ? EditMode.UNPUBLISHED : EditMode.PUBLISHED;
      return {
        ...state,
        tasks: {
          items: newTasks,
          isLoading: false,
          version: uuid(),
          taskSource: source,
        },
        tasksEditMode,
      };
    }
    case types.DELETE_TASK_SUCCESS: {
      const { tasks, taskSource } = action;
      const deletedTaskIds = new Set(tasks.map((t) => t.id));
      return {
        ...state,
        tasks: {
          items: [...state.tasks.items.filter((t) => !deletedTaskIds.has(t.id))],
          isLoading: false,
          version: uuid(),
          taskSource,
        },
      };
    }
    case types.BULK_DELETE_SUCCESSFUL: {
      const virtualTasks = action.tasks.filter((t) => TaskUtilities.isTaskOccurrenceOfRecurringAndVirtual(t));
      const nonVirtualTaskIds = action.tasks
        .filter((t) => !TaskUtilities.isTaskOccurrenceOfRecurringAndVirtual(t))
        .map((t) => t.id);
      let mainTasks = _.cloneDeep(state.tasks.items);

      mainTasks = mainTasks.filter((t) => nonVirtualTaskIds.indexOf(t.id) === -1);

      const mainTaskIdMap = _.keyBy(mainTasks, 'id');

      virtualTasks.forEach((t) => {
        const sourceTask = mainTaskIdMap[t.sourceRecurringTaskId];
        if (sourceTask) {
          sourceTask.deletedForRecurrenceDates = sourceTask.deletedForRecurrenceDates || [];
          sourceTask.deletedForRecurrenceDates.push(t.startTime);
        }
      });

      mainTasks = Object.values(mainTaskIdMap);

      return {
        ...state,
        tasks: {
          items: mainTasks,
          isLoading: false,
          version: uuid(),
          taskSource: TASK_SOURCE.NON_SUBSCRIPTION,
        },
        isPageLoading: false,
      };
    }
    case types.TASK_PAGE_LOADING:
    case types.CREATING_TASK:
    case types.UPDATING_TASK:
    case types.APPROVING_TASK:
      return { ...state, isPageLoading: true };
    case types.SCHEDULER_PAGE_LOADING:
      return { ...state, schedulerPageLoading: true };
    case types.BULK_DELETE_FAILED:
    case types.RUN_ENGINE_FAILED:
    case types.TASK_PAGE_LOADED:
    case types.BULK_UNASSIGNED_USER_FAILED:
    case types.CREATED_TASK_FAILED:
    case types.UPDATED_TASK_FAILED:
    case types.APPROVED_TASK_FAILED:
      return { ...state, isPageLoading: false };
    case types.SCHEDULER_PAGE_LOADED:
      return { ...state, schedulerPageLoading: false };
    case types.UPDATE_DELETED_FOR_RECURRENCE_DATE_TASK_SUCCESS: {
      const task = _.clone(_.find(state.tasks.items, { id: action.task.id }));
      task.deletedForRecurrenceDates = action.task.deletedForRecurrenceDates;
      return {
        ...state,
        tasks: {
          items: [...state.tasks.items.filter((t) => t.id !== action.task.id), task],
          isLoading: false,
          version: uuid(),
        },
      };
    }
    case types.RUN_ENGINE_SUCCESS: {
      console.debug(`${Object.keys(action.tasksDict).length} tasks received from engine`);

      const sequencedTasks = action.tasksDict.sequenced;
      const notSequencedTasks = action.tasksDict.notSequenced;
      const otherTasksFromEngine = action.tasksDict.otherTasks;

      console.debug(`${Object.keys(sequencedTasks).length} tasks sequenced by engine`);
      console.debug(`${Object.keys(notSequencedTasks).length} tasks not sequenced by engine`);
      console.debug(`${Object.keys(otherTasksFromEngine).length} other tasks received for planning`);

      // tasks in state which got sequenced for the run
      const tasksSequencedInState = state.tasks.items
        .filter((t) => sequencedTasks[t.id])
        .map((t) => {
          const { assignee, assigneeIds, startTime, endTime } = sequencedTasks[t.id];
          return { ...t, assignee, assigneeIds, startTime, endTime, isDirty: true };
        });

      // tasks in state which are not sequenced for the run
      const tasksNotSequencedInState = state.tasks.items
        .filter((t) => notSequencedTasks[t.id])
        .map((t) => setSequenceNullAndStateDirtyToTaskForAssigneeId(t, action.engineParameters.assigneeId));

      // tasks in state which are other than "sequenced and not sequenced"
      let otherTasksInState = state.tasks.items.filter((t) => !sequencedTasks[t.id] && !notSequencedTasks[t.id]);

      // remove virtual tasks in state who are same or similar to sequenced tasks manifested in input service
      const nonVirtualTasksInState = otherTasksInState.filter(
        (t) => !TaskUtilities.isTaskOccurrenceOfRecurringAndVirtual(t)
      );
      const virtualTasksInState = otherTasksInState.filter((t) =>
        TaskUtilities.isTaskOccurrenceOfRecurringAndVirtual(t)
      );
      const virtualTasksNeeded = combineVirtualTasksWithDbTasks(
        virtualTasksInState,
        [...Object.values(sequencedTasks), ...Object.values(notSequencedTasks)],
        true
      );
      otherTasksInState = nonVirtualTasksInState.concat(virtualTasksNeeded);

      // task Ids which are not in state
      const allTasksIds = Object.keys(sequencedTasks)
        .concat(Object.keys(notSequencedTasks))
        .concat(Object.keys(otherTasksFromEngine));
      const stateTasksDict = _.keyBy(state.tasks.items, 'id');
      const tasksIdsNotInState = allTasksIds.filter((i) => !stateTasksDict[i]);

      const tasksNotInState = tasksIdsNotInState
        .map((id) => {
          let newTask;
          if (sequencedTasks[id]) {
            newTask = { ...sequencedTasks[id] };
          }
          if (notSequencedTasks[id]) {
            newTask = { ...notSequencedTasks[id] };
          }
          if (otherTasksFromEngine[id]) {
            newTask = { ...otherTasksFromEngine[id] };
          }

          newTask.isDirty = true;

          // need to think about unAssigned and otherTasks
          // TO DO
          // if (notSequencedTasks[id]) {
          //   newTask = Object.assign({}, notSequencedTasks[id]);
          //   newTask = setSequenceNullAndStateDirtyToTaskForAssigneeId(newTask, action.engineParameters.assigneeId);
          // }
          if (newTask) {
            delete newTask.includeNextDay;
            delete newTask.sameAssigneeAsNextDay;
          }
          return newTask;
        })
        .filter((task) => task);

      return {
        ...state,
        tasks: {
          items: [...tasksSequencedInState, ...tasksNotSequencedInState, ...otherTasksInState, ...tasksNotInState],
          isLoading: false,
          version: uuid(),
          taskSource: TASK_SOURCE.NON_SUBSCRIPTION,
        },
        isPageLoading: false,
      };
    }
    case types.LOADING_ALL_USERS:
      return {
        ...state,
        users: {
          ...state.users,
          // items: [],
          isLoading: true,
        },
      };
    case types.LOADED_ALL_USERS:
      return {
        ...state,
        users: {
          items: action.users,
          isLoading: false,
        },
      };
    case types.LOADING_ALL_USERS_FAILED:
      return {
        ...state,
        users: {
          items: [],
          isLoading: false,
        },
      };
    case types.TASK_TIME_UPDATED: {
      const task = state.tasks.items.find((t) => t.id === action.task.id);
      if (task) {
        const clonedTask = _.cloneDeep(task);
        clonedTask.startTime = action.task.startTime;
        clonedTask.endTime = action.task.endTime;
        clonedTask.duration = action.task.duration;
        return {
          ...state,
          tasks: {
            items: [...state.tasks.items.filter((t) => t.id !== action.task.id), clonedTask],
            isLoading: false,
            version: uuid(),
            taskSource: TASK_SOURCE.NON_SUBSCRIPTION,
          },
          isPageLoading: false,
        };
      }
      return state;
    }
    case types.BULK_UNASSIGNED_USER_SUCCESSFUL: {
      const unassignedTasks = _.cloneDeep(state.tasks.items.filter((t) => action.taskIds.indexOf(t.id) > -1));
      for (const task of unassignedTasks) {
        task.assigneeIds = [];
        task.assignee = null;
      }
      return {
        ...state,
        tasks: {
          items: [...state.tasks.items.filter((t) => action.taskIds.indexOf(t.id) === -1), ...unassignedTasks],
          isLoading: false,
          version: uuid(),
          taskSource: TASK_SOURCE.NON_SUBSCRIPTION,
        },
        isPageLoading: false,
      };
    }
    case types.UPDATE_TASK_TIME_DIRTY_STATE: {
      const updatedTask = _.cloneDeep(state.tasks.items.find((t) => action.updateTaskObj.id === t.id));
      Object.assign(updatedTask, action.updateTaskObj);
      return {
        ...state,
        tasks: {
          items: [...state.tasks.items.filter((t) => action.updateTaskObj.id !== t.id), updatedTask],
          isLoading: false,
          version: uuid(),
          taskSource: TASK_SOURCE.NON_SUBSCRIPTION,
        },
      };
    }
    case types.GRID_DATE_CHANGED: {
      return { ...state, selectedDateRange: action.date };
    }
    case types.CHANGE_TASK_VIEW_PAGE_VIEW: {
      const clonedViewStack = _.clone(state.viewStack);
      // eslint-disable-next-line prefer-destructuring
      clonedViewStack[1] = clonedViewStack[0];
      clonedViewStack[0] = action.view;
      return { ...state, viewStack: clonedViewStack, currentView: action.view };
    }
    case types.UPDATE_TASKS_FROM_SCHEDULER: {
      const { tasks } = action;
      const {
        usersAtFieldLevel,
        users: { items: usersAtAreaLevel },
      } = state;
      console.debug(action);
      const modifiedTasks = [];
      for (const task of tasks) {
        const clonedTask = _.clone(state.tasks.items.find((t) => t.id === task.id));
        clonedTask.startTime = task.startTime;
        clonedTask.duration = task.duration;
        clonedTask.endTime = moment(task.startTime).add(task.duration, 'minutes').toISOString();
        const needEquipment = clonedTask?.taskType?.needEquipment || false;
        clonedTask.assigneeIds = mergeAssigneeIdsWithDeletedAssigneeIds(
          (task.assigneeIds || []).filter((t) => !t.isDeleted),
          clonedTask.assigneeIds,
          usersAtFieldLevel,
          needEquipment
        );
        const assignee = {};
        clonedTask.assigneeIds
          .filter((a) => !a.isDeleted)
          .forEach((item) => {
            assignee[item.assigneeId] =
              usersAtFieldLevel.find((u) => item.assigneeId === u.id) ||
              usersAtAreaLevel.find((u) => item.assigneeId === u.id);
          });
        clonedTask.assignee = JSON.stringify(assignee);
        clonedTask.isDirty = true;
        clonedTask.status = task.status;
        clonedTask.priority = task.priority;
        modifiedTasks.push(clonedTask);
      }
      const modifiedTaskIds = new Set(modifiedTasks.map((t) => t.id));
      return {
        ...state,
        tasks: {
          items: [...state.tasks.items.filter((t) => !modifiedTaskIds.has(t.id)), ...modifiedTasks],
          isLoading: false,
          version: state.tasks.version,
          taskSource: TASK_SOURCE.NON_SUBSCRIPTION,
        },
        tasksEditMode: EditMode.UNPUBLISHED,
      };
    }
    case types.CHANGE_TASK_EDIT_MODE: {
      const { mode } = action;
      return { ...state, tasksEditMode: mode };
    }
    case types.CHANGE_TASK_PLANNING_MODE: {
      const { mode } = action;
      return { ...state, tasksPlanningState: mode };
    }
    case types.CHANGE_TASK_PLANNING_MESSAGE: {
      const { message } = action;
      return { ...state, tasksPlanningMessage: message };
    }
    case types.LOAD_USERS_AT_FIELD_LEVEL_SUCCESS: {
      const { users } = action;
      return { ...state, usersAtFieldLevel: users };
    }
    case types.LOAD_USERS_AT_FIELD_LEVEL_FAILED: {
      return { ...state, usersAtFieldLevel: [] };
    }
    case types.CREATED_TASK_SUCCESSFULLY:
    case types.UPDATED_TASK_SUCCESSFULLY:
    case types.APPROVED_TASK_SUCCESSFULLY: {
      const { task, picklistOptions, tenantId, stopForSelectedAsset } = action;
      const oldTask = state.tasks.items.find((t) => t.id === task.id);
      const normalizedTask = TaskUtilities.updateNormalizedTaskProperties(
        task,
        oldTask,
        picklistOptions,
        tenantId,
        stopForSelectedAsset
      );
      return {
        ...state,
        tasks: {
          items: [...state.tasks.items.filter((t) => t.id !== normalizedTask.id), normalizedTask],
          isLoading: false,
          version: uuid(),
          taskSource: TASK_SOURCE.NON_SUBSCRIPTION,
        },
        isPageLoading: false,
      };
    }
    case types.LOAD_TASK_USERS_SUBSCRIPTION_SUCCESS: {
      const { usersInfo, selectedAreas, fieldId } = action;
      const usersAtSelectedAreas = _.cloneDeep(state.users);
      const usersItemsArSelectedArea = usersAtSelectedAreas.items;
      const fieldUsers = _.cloneDeep(state.usersAtFieldLevel);
      usersInfo.forEach((user) => {
        if (user.fieldId === fieldId) {
          helper.userInsertOrUpdate(fieldUsers, user);
        }
        if (doesUserBelongToAreas(selectedAreas, user)) {
          helper.userInsertOrUpdate(usersItemsArSelectedArea, user);
        }
      });
      usersAtSelectedAreas.isLoading = false;

      return {
        ...state,
        users: usersAtSelectedAreas,
        usersAtFieldLevel: _.uniqBy(fieldUsers, 'id'),
      };
    }
    case types.UPDATE_MERGE_TASK: {
      const { task } = action;
      const originalTask = state.tasks.items.find((t) => t.id === task.id) || {};
      const updatedTask = { ...originalTask, ...task };
      return {
        ...state,
        tasks: {
          items: [...state.tasks.items.filter((t) => t.id !== task.id), updatedTask],
          isLoading: false,
          version: uuid(),
          taskSource: TASK_SOURCE.NON_SUBSCRIPTION,
        },
        isPageLoading: false,
      };
    }
    case types.UPDATE_TEAMS_OF_USERS: {
      const { updatedUsers } = action;
      const updatedUserDict = _.keyBy(updatedUsers, 'id');
      const usersWithUpdatedTeams = state.usersAtFieldLevel.map((user) => {
        const clonedUser = _.clone(user);
        const userInDict = updatedUserDict[user.id];
        if (userInDict) {
          clonedUser.teams = userInDict.teams;
        }
        return clonedUser;
      });
      return {
        ...state,
        usersAtFieldLevel: usersWithUpdatedTeams,
      };
    }
    case actionTypes.SET_USERS: {
      const { users } = action;
      return { ...state, users: { ...state.users, items: users } };
    }
    case actionTypes.SET_TASKS: {
      const { tasks, taskSource, doNotUpdateVersion } = action;
      return {
        ...state,
        tasks: {
          ...state.tasks,
          items: tasks,
          taskSource,
          version: doNotUpdateVersion ? state.tasks.version : uuid(),
        },
      };
    }
    case types.LOAD_FILTERS: {
      const { filters } = action;
      return {
        ...state,
        filters: {
          items: filters,
        },
      };
    }
    case types.UPSERT_FILTER: {
      const { filter } = action;
      return {
        ...state,
        filters: {
          items: [...state.filters.items.filter((t) => t.id !== filter.id), filter],
        },
      };
    }
    case types.DELETE_FILTER: {
      const { id } = action;
      return {
        ...state,
        filters: {
          items: [...state.filters.items.filter((t) => t.id !== id)],
        },
      };
    }
    case types.UPSERT_PARENT_CHILD_TASKS: {
      const { tasks } = action;
      return {
        ...state,
        parentChildTasks: {
          items: tasks,
        },
      };
    }
    case types.UPDATE_PARENT_CHILD_MERGE_TASK: {
      const { task } = action;
      console.log(task);
      const originalTask = state.parentChildTasks.items.find((t) => t.id === task.id) || {};
      const updatedTask = { ...originalTask, ...task };
      return {
        ...state,
        parentChildTasks: {
          items: [...state.parentChildTasks.items.filter((t) => t.id !== task.id), updatedTask],
        },
      };
    }
    case types.UPDATE_SELECTED_USER_IDS: {
      const { userIds = [] } = action;
      return {
        ...state,
        selectedUserIds: [...userIds],
      };
    }
    case types.LOCK_TASKS_FROM_SCHEDULER: {
      const { taskIds = [], isTaskLocked, isDirty } = action;
      let { tasksEditMode } = state;
      console.log('taskIds', taskIds);
      if (!isDirty) {
        const dirtyTasks = state.tasks.items.filter((val) => !taskIds.includes(val.id) && val.isDirty);
        tasksEditMode = dirtyTasks.length ? EditMode.UNPUBLISHED : EditMode.PUBLISHED;
      } else {
        tasksEditMode = EditMode.UNPUBLISHED;
      }
      return {
        ...state,
        tasks: {
          items: [
            ...state.tasks.items.map((t) => {
              if (taskIds.includes(t.id)) {
                return { ...t, isTaskLocked, isDirty };
              }
              return t;
            }),
          ],
          isLoading: false,
          version: state.tasks.version,
          taskSource: TASK_SOURCE.NON_SUBSCRIPTION,
        },
        tasksEditMode,
        isPageLoading: false,
      };
    }
    case types.UPDATE_PARENT_CHILD_TASKS: {
      const { tasks = [] } = action;
      const tasksDict = _.keyBy(tasks, 'id');
      return {
        ...state,
        parentChildTasks: {
          items: [...state.parentChildTasks.items.filter((t) => !tasksDict[t.id]), ...tasks],
        },
      };
    }
    case types.UPSERT_ASSET_LEVELS_INFO: {
      const { assetLevelsObjects = {} } = action;
      return {
        ...state,
        assetLevelsDict: { ...state.assetLevelsDict, ...assetLevelsObjects },
      };
    }
    case types.UPSERT_WATCHERS: {
      const { watchers = {} } = action;
      return {
        ...state,
        watcherDetailsDict: { ...state.watcherDetailsDict, ...watchers },
      };
    }
    default:
      return state;
  }
}

export const getTaskByIdSelector = (taskId) => (state) =>
  state.taskViewPageReducer.tasks.items.find((task) => task.id === taskId);
export const getChildTasksByParentTaskIdSelector = (parentTaskId) => (state) =>
  state.taskViewPageReducer.tasks.items.filter((task) => task.parentTaskId === parentTaskId);
export const getChildTasksForParentTaskCard = (parentTaskId) => (state) =>
  state.taskViewPageReducer.parentChildTasks.items.filter((task) => task.parentTaskId === parentTaskId);

export const isTaskViewLoadingSelector = (state) => {
  const {
    tasks: { isLoading: isTaskLoading },
    users: { isLoading: isUsersLoading },
    isPageLoading,
  } = state.taskViewPageReducer;
  return isTaskLoading || isUsersLoading || isPageLoading;
};
